/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerLeftUp = createReactComponent("outline", "corner-left-up", "IconCornerLeftUp", [["path", { "d": "M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4", "key": "svg-0" }]]);

export { IconCornerLeftUp as default };
//# sourceMappingURL=IconCornerLeftUp.mjs.map
